import { Action, Category } from "constants/events";
import { trackEvent } from "utils/trackEvent";

import Image from "components/Image";

type Props = {
  date: string;
  imageUrl: string;
  readAt: string;
  text: string;
  title: string;
  href: string;
};
/**
 * Notification cards are used to display notifications, such as deals posted by a dispensary.
 */
const NotificationCard = ({
  date,
  imageUrl,
  readAt,
  text,
  title,
  href,
  ...others
}: Props) => {
  const trackNotificationClick = () => {
    trackEvent(Category.webProfile, Action.notificationClick, href);
  };

  return (
    // TODO: Can be converted to next/link once /bag and /checkout uses getServersideProps
    <a
      className="update-card p-sm rounded shadow-low"
      {...others}
      href={href}
      onClick={trackNotificationClick}
    >
      {!readAt && (
        <div className="absolute -ml-md rounded-full w-[10px] h-[10px] bg-notification"></div>
      )}
      <header className="card__header border-b-1 border-light-grey pb-xs">
        <div className="flex pt-xs pb-md">
          {imageUrl && (
            <div className="rounded-full mr-md ml-xs w-[42px] h-[42px] overflow-hidden">
              <Image sizes={[42]} alt="store logo" src={imageUrl} />
            </div>
          )}
          <div className="pt-xs">
            <div className="text-m font-bold text-green">{title}</div>
            <div className="text-xs text-default pt-xs">
              {new Date(date).toLocaleString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </div>
          </div>
        </div>
      </header>
      <div className="text-default">{text}</div>
    </a>
  );
};

export default NotificationCard;
